<template>
  <div>
    <card>
      <!-- Card header -->
      <h3 slot="header" class="mb-0"><span class="text-muted"># {{orderindex}}. </span>{{stage}}. {{title}}</h3>
      <!-- Card body -->
      <!-- Input groups with icon -->

      <div class="row">
        <div class="col-md-2">
          <b>Description</b>
        </div>
        <div class="col-md-10">
          <span v-html="htmldescription" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <b>Duration</b>
        </div>
        <div class="col-md-10">
          <span>{{duration}} min</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <b>Notes</b>
        </div>
        <div class="col-md-10">
          <i>{{notes}}</i>
        </div>
      </div>
      <!-- <el-collapse v-model="activeNames">
        <el-collapse-item title="Tasks" name="1">
          
        </el-collapse-item>
      </el-collapse> -->
    </card>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "element-ui";
import { ShowLink, HtmlNewLine } from "../../../services/helper"
export default {
  name: "lesson-item",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
  },
  props: {
    title: String,
    notes: String,
    description: String,
    stage: String,
    orderindex: String,
    duration: [Number, String]
  },
  computed: {
    htmldescription() {
      return ShowLink(HtmlNewLine(this.description));
    }
  },
  data() {
    return {
      activeNames: ""
    };
  }
};
</script>

<style lang="scss" scoped>
</style>